// export default 'http://bubo.jp/wordpress/';
export default 'http://oyakohug.com/';



// WEBPACK FOOTER //
// ./src/wp_url.js